export default "/images/vendor/flag-icon-css/flags/1x1/hn.svg?ebef2cd564ca07f12aa10d84048e0496";